import DashboardStats from "./components/DashboardStats";
import ChannelBalancesSection from "./components/ChannelBalancesSection";
import DashboardCharts from "./components/DashboardCharts";
import RecentPayoutsSection from "./components/RecentPayoutsSection";

export default function MerchantDashBoard() {
  return (
    <div className="flex flex-col min-h-full">
      <div className="flex-1">
        <DashboardStats />
        <ChannelBalancesSection />
        <DashboardCharts />
        <RecentPayoutsSection />
      </div>
    </div>
  );
}
